var yup = require('yup');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return n;
}

var yup__namespace = /*#__PURE__*/_interopNamespace(yup);

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var validUrl = createCommonjsModule(function (module) {
  (function (module) {

    module.exports.is_uri = is_iri;
    module.exports.is_http_uri = is_http_iri;
    module.exports.is_https_uri = is_https_iri;
    module.exports.is_web_uri = is_web_iri; // Create aliases

    module.exports.isUri = is_iri;
    module.exports.isHttpUri = is_http_iri;
    module.exports.isHttpsUri = is_https_iri;
    module.exports.isWebUri = is_web_iri; // private function
    // internal URI spitter method - direct from RFC 3986

    var splitUri = function splitUri(uri) {
      var splitted = uri.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
      return splitted;
    };

    function is_iri(value) {
      if (!value) {
        return;
      } // check for illegal characters


      if (/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(value)) return; // check for hex escapes that aren't complete

      if (/%[^0-9a-f]/i.test(value)) return;
      if (/%[0-9a-f](:?[^0-9a-f]|$)/i.test(value)) return;
      var splitted = [];
      var scheme = '';
      var authority = '';
      var path = '';
      var query = '';
      var fragment = '';
      var out = ''; // from RFC 3986

      splitted = splitUri(value);
      scheme = splitted[1];
      authority = splitted[2];
      path = splitted[3];
      query = splitted[4];
      fragment = splitted[5]; // scheme and path are required, though the path can be empty

      if (!(scheme && scheme.length && path.length >= 0)) return; // if authority is present, the path must be empty or begin with a /

      if (authority && authority.length) {
        if (!(path.length === 0 || /^\//.test(path))) return;
      } else {
        // if authority is not present, the path must not start with //
        if (/^\/\//.test(path)) return;
      } // scheme must begin with a letter, then consist of letters, digits, +, ., or -


      if (!/^[a-z][a-z0-9\+\-\.]*$/.test(scheme.toLowerCase())) return; // re-assemble the URL per section 5.3 in RFC 3986

      out += scheme + ':';

      if (authority && authority.length) {
        out += '//' + authority;
      }

      out += path;

      if (query && query.length) {
        out += '?' + query;
      }

      if (fragment && fragment.length) {
        out += '#' + fragment;
      }

      return out;
    }

    function is_http_iri(value, allowHttps) {
      if (!is_iri(value)) {
        return;
      }

      var splitted = [];
      var scheme = '';
      var authority = '';
      var path = '';
      var port = '';
      var query = '';
      var fragment = '';
      var out = ''; // from RFC 3986

      splitted = splitUri(value);
      scheme = splitted[1];
      authority = splitted[2];
      path = splitted[3];
      query = splitted[4];
      fragment = splitted[5];
      if (!scheme) return;

      if (allowHttps) {
        if (scheme.toLowerCase() != 'https') return;
      } else {
        if (scheme.toLowerCase() != 'http') return;
      } // fully-qualified URIs must have an authority section that is
      // a valid host


      if (!authority) {
        return;
      } // enable port component


      if (/:(\d+)$/.test(authority)) {
        port = authority.match(/:(\d+)$/)[0];
        authority = authority.replace(/:\d+$/, '');
      }

      out += scheme + ':';
      out += '//' + authority;

      if (port) {
        out += port;
      }

      out += path;

      if (query && query.length) {
        out += '?' + query;
      }

      if (fragment && fragment.length) {
        out += '#' + fragment;
      }

      return out;
    }

    function is_https_iri(value) {
      return is_http_iri(value, true);
    }

    function is_web_iri(value) {
      return is_http_iri(value) || is_https_iri(value);
    }
  })(module);
});

var graphQlTypeNames = ['int', 'float', 'string', 'boolean', 'enum', 'interface', 'union', 'fragment', 'datetime', 'json', 'mutation', 'subscription', 'scalar', 'query', 'input', 'node'];
var reservedNonSystemTypeNames = ['Id', 'User', 'Search', 'Status', 'Locale', 'RichText', 'RichTextAST', 'Location', 'LocationInput', 'Color', 'ColorInput', 'RGBATransparency', 'RGBAHue', 'HEX', 'RGBA', 'ScheduledRelease', 'ScheduledOperation', 'Entity', 'Entities', 'EntityTypeName'];
var reservedNonSystemFieldNames = ['id', 'createdat', 'updatedat', 'versions', 'createdby', 'status', 'publishedat', 'localizations', 'documentInStages', 'publish', 'locale', 'updatedby', 'publishedby'];
var reservedModelApiIds = ['Type'].concat(reservedNonSystemTypeNames);
var reservedEnumerationApiIds = ['Type'].concat(reservedNonSystemTypeNames);
var reservedEnumerationValueApiIds = ['null', 'true', 'false'];
var reservedFieldApiIds = reservedNonSystemFieldNames;

var safeStringify = function safeStringify(x) {
  try {
    return JSON.stringify(x);
  } catch (e) {}

  return x;
};

yup__namespace.setLocale({
  mixed: {
    notType: function notType(_ref) {
      var type = _ref.type,
          value = _ref.value,
          originalValue = _ref.originalValue;
      return "The supplied value \"" + safeStringify(value) + "\" of type \"" + typeof originalValue + "\" is not compatible with type \"" + type + "\"!";
    },
    notOneOf: '"${value}" is a restricted word and cannot be used here.'
  }
});
yup__namespace.addMethod(yup__namespace.string, 'url', function url() {
  return this.test('is-valid-url', 'Only valid URLs are supported!', function (value) {
    return value != null ? !!validUrl.isUri(value) : true;
  });
});
yup__namespace.addMethod(yup__namespace.string, 'httpsUrl', function httpsUrl() {
  return this.test('is-https-url', 'Only HTTPS URLs are supported!', function (value) {
    return value != null ? !!validUrl.isHttpsUri(value) : true;
  });
});
yup__namespace.addMethod(yup__namespace.string, 'noGqlType', function noGqlType() {
  return this.test({
    name: 'no-graphql-type',
    test: function test(value) {
      return !graphQlTypeNames.some(function (reservedWord) {
        return value ? reservedWord === value.toLowerCase() : false;
      });
    },
    message: '"${value}" is a restricted word and cannot be used here.',
    exclusive: false
  });
});

var name$6 = yup__namespace.string().strict(true).min(1).ensure().trim('The name of an authentication token may not start or end with white space characters.');
var description$6 = yup__namespace.string().nullable(true);
var scope = yup__namespace.string().strict(true).oneOf(['READ', 'WRITE', 'OPEN'], "An authentication token can only be set to one of 'READ', 'WRITE' or 'OPEN'");

var authtoken = {
	__proto__: null,
	name: name$6,
	description: description$6,
	scope: scope
};

/**
 * Matcher for enumeration api IDs:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .min()             -> Sets minimum required length of string to 1 character
 * .max()             -> Sets maximum required length of string to 64 characters
 * .matches(:RegExpr) -> Matches the input value against a regular expression
 */

var apiId$6 = yup__namespace.string().min(1, 'Enter an Api Id.').max(64, 'Use an Api Id that is shorter than ${max} characters.').noGqlType().test({
  name: 'no-reserved-word',
  test: function test(value) {
    var options = this.options;

    if (options.context && options.context.isSystem) {
      return true;
    }

    var reservedApiIds = reservedEnumerationApiIds;

    if (options.context && options.context.isLocalized) {
      // @ts-expect-error
      reservedApiIds = reservedEnumerationApiIds.filter(function (word) {
        return word !== 'Locale';
      });
    }

    return !reservedApiIds.some(function (reservedWord) {
      return value ? reservedWord.toLowerCase() === value.toLowerCase() : false;
    });
  },
  message: '"${value}" is a restricted word and cannot be used here.',
  exclusive: false
}).matches(/^[A-Z][a-zA-Z0-9_]*$/, 'Start with a capital letter and use only alphanumeric characters and underscores.'); // <-- RegEx from Prisma

/**
 * Matcher for enumeration api IDs:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .trim()            -> Since strict is true, this only validates that the input value is trimmed
 *                       This means that it checks that the value does not have any leading or trailing whitespaces.
 */

var displayName$5 = yup__namespace.string().min(1, 'Enter a Display Name.').trim('The display name may not have leading or trailing whitespaces.');
/**
 * Matcher for model descriptions:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .ensure()          -> Transforms the values "undefined" and "null" into empty strings
 */

var description$5 = yup__namespace.string();
/**
 * Matcher for enumeration api IDs:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .strict(:boolean)  -> Prevents manipulation of the string during validation
 * .min()             -> Sets minimum required length of string to 1 character
 * .max()             -> Sets maximum required length of string to 64 characters
 * .test()            -> Executes an arbitrary test on the input value
 * .matches(:RegExpr) -> Matches the input value against a regular expression
 */

var valueItemApiId = yup__namespace.string().min(1, 'Enter a value.').max(191, 'Use a value that is shorter than ${max} characters.').test({
  name: 'no-reserved-word',
  test: function test(value) {
    var options = this.options;

    if (options.context && options.context.isSystem) {
      return true;
    }

    return !reservedEnumerationValueApiIds.some(function (reservedWord) {
      return value ? reservedWord.toLowerCase() === value.toLowerCase() : false;
    });
  },
  message: '"${value}" is a restricted word and cannot be used here.',
  exclusive: false
}).matches(/^[a-zA-Z][a-zA-Z0-9_]*$/, 'Start with a letter, and use only alphanumeric characters or underscores.');
var valueItemDisplayName = displayName$5;
var enumerationId = yup__namespace.string().strict(true);

var enumeration = {
	__proto__: null,
	apiId: apiId$6,
	displayName: displayName$5,
	description: description$5,
	valueItemApiId: valueItemApiId,
	valueItemDisplayName: valueItemDisplayName,
	enumerationId: enumerationId
};

/**
 * Matcher for field api IDs:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .strict(:boolean)  -> Prevents manipulation of the string during validation
 * .min()             -> Sets minimum required length of string to 1 character
 * .max()             -> Sets maximum required length of string to 64 characters
 * .test()            -> Executes an arbitrary test on the input value
 * .matches(:RegExpr) -> Matches the input value against a regular expression
 */

var apiId$5 = yup__namespace.string().strict(true).min(1, 'Enter an Api Id.').max(64, 'Use an Api Id that is shorter than ${max} characters.').noGqlType().test({
  name: 'no-reserved-word',
  test: function test(value) {
    var options = this.options;

    if (options.context && options.context.isSystem) {
      return true;
    }

    return !reservedFieldApiIds.some(function (reservedWord) {
      return value ? reservedWord === value.toLowerCase() : false;
    });
  },
  message: '"${value}" is a restricted word and cannot be used here.',
  exclusive: false
}).matches(/^[a-z][a-zA-Z0-9_]*$/, 'Start with a lowercase letter and use only alphanumeric characters and underscores.'); // <-- Those are validations enforced by prisma: https://github.com/graphcool/prisma/blob/master/server/servers/deploy/src/main/scala/com/prisma/deploy/validation/NameConstraints.scala

/**
 * Matcher for field api IDs for the reverse relation side:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .strict(:boolean)  -> Prevents manipulation of the string during validation
 * .min()             -> Sets minimum required length of string to 1 character
 * .max()             -> Sets maximum required length of string to 64 characters
 * .test()            -> Executes an arbitrary test on the input value
 * .matches(:RegExpr) -> Matches the input value against a regular expression
 */

var reverseRelationFieldApiId = apiId$5.concat(yup__namespace.string().max(64, 'The API ID of a field may not exceed ${max} characters.'));
/**
 * Matcher for field display names:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .strict(:boolean)  -> Prevents manipulation of the string during validation
 * .min()             -> Sets minimum required length of string to 1 character
 * .max()             -> Sets maximum required length of string to 64 characters
 * .test()            -> Executes an arbitrary test on the input value
 */

var displayName$4 = yup__namespace.string().strict(true).min(1, 'Enter a Display Name.').max(64, 'The Display Name of a field may not exceed ${max} characters.').test('no-letter', 'Enter a Display Name.', function (value) {
  if (!value) {
    return true;
  }

  if (value && typeof value === 'string') {
    return value.replace(/\s/g, '').length > 0;
  }

  return false;
});
/**
 * Matcher for field descriptions:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .ensure()          -> Transforms the values "undefined" and "null" into empty strings
 */

var description$4 = yup__namespace.string().nullable(true).ensure();
var isList = yup__namespace["boolean"]().strict(true);
var isHidden = yup__namespace["boolean"]().strict(true);
var isApiOnly = yup__namespace["boolean"]().strict(true);
var isReadOnly = yup__namespace["boolean"]().strict(true);

var field = {
	__proto__: null,
	apiId: apiId$5,
	reverseRelationFieldApiId: reverseRelationFieldApiId,
	displayName: displayName$4,
	description: description$4,
	isList: isList,
	isHidden: isHidden,
	isApiOnly: isApiOnly,
	isReadOnly: isReadOnly
};

var email = yup__namespace.string().nullable(false).min(1).email('Only valid E-Mail addresses are allowed.');

var invite = {
	__proto__: null,
	email: email
};

/**
 * Matcher for model api IDs:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .strict(:boolean)  -> Prevents manipulation of the string during validation
 * .min()             -> Sets minimum required length of string to 1 character
 * .max()             -> Sets maximum required length of string to 64 characters
 * .required()        -> Ensures that empty strings are treated as invalid value
 * .test()            -> Executes an arbitrary test on the input value
 * .matches(:RegExpr) -> Matches the input value against a regular expression
 */

var apiId$4 = yup__namespace.string().strict(true).min(1, 'Enter an Api ID.').max(64, 'Use an Api Id that is shorter than ${max} characters.').noGqlType().test({
  name: 'no-reserved-word',
  test: function test(value) {
    var options = this.options;

    if (options.context && options.context.isSystem) {
      return true;
    }

    return !reservedModelApiIds.some(function (reservedWord) {
      return value ? reservedWord.toLowerCase() === value.toLowerCase() : false;
    });
  },
  message: '"${value}" is a restricted word and cannot be used here.',
  exclusive: false
}).matches(/^[A-Z][a-zA-Z0-9_]*$/, 'Start with a capital letter and use only alphanumeric characters and underscores.'); // <-- Those are validations enforced by prisma: https://github.com/graphcool/prisma/blob/master/server/servers/deploy/src/main/scala/com/prisma/deploy/validation/NameConstraints.scala

/**
 * Matcher for model display names:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .strict(:boolean)  -> Prevents manipulation of the string during validation
 * .required()        -> Ensures that empty strings are treated as invalid value
 */

var displayName$3 = yup__namespace.string().strict(true).min(1, 'Enter a Display Name').trim('Display names may not have leading or trailing whitespaces.');
/**
 * Matcher for model descriptions:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .ensure()          -> Transforms the values "undefined" and "null" into empty strings
 */

var description$3 = yup__namespace.string().ensure();
var modelId = yup__namespace.string().strict(true);
var previewURLs = yup__namespace.array().of(yup__namespace.object().shape({
  name: yup__namespace.string().required(),
  template: yup__namespace.string().required()
}).required());

var model = {
	__proto__: null,
	apiId: apiId$4,
	displayName: displayName$3,
	description: description$3,
	modelId: modelId,
	previewURLs: previewURLs
};

var API_REGIONS = ['EU_WEST_1', 'EU_WEST_3', 'US_EAST_1', 'US_WEST_1', 'AP_NORTHEAST_1']; // Use this for identifiers: "^[a-zA-Z][a-zA-Z0-9\\-_~]*$"

var name$5 = yup__namespace.string().min(1, 'Enter a Name').nullable(false).strict(true);
var region = yup__namespace.string().nullable(false).strict(true).min(1).oneOf(API_REGIONS, 'The region can only be one of these values: ${values}');
var description$2 = yup__namespace.string();
var url$1 = yup__namespace.string().strict(true).min(1).url('The custom prisma endpoint must be a valid url!').test('no-end-with-management', 'The custom prisma endpoint may not end with "/management"', function (value) {
  if (!value) return false;
  return !value.endsWith('/management');
});
var token = yup__namespace.string().strict(true).required('A token can not be empty!');
var customPrisma = {
  url: url$1,
  token: token
};

var project = {
	__proto__: null,
	API_REGIONS: API_REGIONS,
	name: name$5,
	region: region,
	description: description$2,
	customPrisma: customPrisma
};

var name$4 = yup__namespace.string().strict(true).trim('The role name may not start or end with whitespace characters.').min(1, 'Choose a name for this role.').max(32, 'Choose an name that is shorter than ${max} characters.');

var role = {
	__proto__: null,
	name: name$4
};

var apiId$3 = yup__namespace.string().strict(true).trim('The Api Id of a stage may not start or end with whitespace characters!').min(1, 'Enter an Api Id.').max(32, 'Choose a Api Id that is shorter than ${max} characters.').matches(new RegExp('^[a-zA-Z][a-zA-Z0-9_]*$'), 'Start with a letter, and use only alphanumeric characters and "_".');
var displayName$2 = yup__namespace.string().strict(true).min(1, 'Choose a Display Name.').trim('Display names may not have leading or trailing whitespaces.');

var stage = {
	__proto__: null,
	apiId: apiId$3,
	displayName: displayName$2
};

var AppElementType;

(function (AppElementType) {
  AppElementType["field"] = "field";
  AppElementType["formSidebar"] = "formSidebar";
  AppElementType["page"] = "page";
})(AppElementType || (AppElementType = {}));

var AppInstallationStatus;

(function (AppInstallationStatus) {
  AppInstallationStatus["COMPLETED"] = "COMPLETED";
  AppInstallationStatus["DISABLED"] = "DISABLED";
  AppInstallationStatus["PENDING"] = "PENDING";
})(AppInstallationStatus || (AppInstallationStatus = {}));

var AppPublicationStatus;

(function (AppPublicationStatus) {
  AppPublicationStatus["PENDING"] = "PENDING";
  AppPublicationStatus["PRIVATE"] = "PRIVATE";
  AppPublicationStatus["PUBLIC"] = "PUBLIC";
})(AppPublicationStatus || (AppPublicationStatus = {}));

var AuditLogAction;

(function (AuditLogAction) {
  AuditLogAction["ACCEPT"] = "ACCEPT";
  AuditLogAction["CREATE"] = "CREATE";
  AuditLogAction["DELETE"] = "DELETE";
  AuditLogAction["PUBLISH"] = "PUBLISH";
  AuditLogAction["UNPUBLISH"] = "UNPUBLISH";
  AuditLogAction["UPDATE"] = "UPDATE";
})(AuditLogAction || (AuditLogAction = {}));

var AuditLogOrderByInput;

(function (AuditLogOrderByInput) {
  AuditLogOrderByInput["timestamp_ASC"] = "timestamp_ASC";
  AuditLogOrderByInput["timestamp_DESC"] = "timestamp_DESC";
})(AuditLogOrderByInput || (AuditLogOrderByInput = {}));

var AuditLogResource;

(function (AuditLogResource) {
  AuditLogResource["COMPONENT"] = "COMPONENT";
  AuditLogResource["CONTENT"] = "CONTENT";
  AuditLogResource["CONTENTVIEW"] = "CONTENTVIEW";
  AuditLogResource["ENUMERATION"] = "ENUMERATION";
  AuditLogResource["ENUMERATION_VALUE"] = "ENUMERATION_VALUE";
  AuditLogResource["ENVIRONMENT"] = "ENVIRONMENT";
  AuditLogResource["EXTENSION"] = "EXTENSION";
  AuditLogResource["FIELD"] = "FIELD";
  AuditLogResource["INVITE"] = "INVITE";
  AuditLogResource["LOCALE"] = "LOCALE";
  AuditLogResource["MEMBER"] = "MEMBER";
  AuditLogResource["MODEL"] = "MODEL";
  AuditLogResource["PAT"] = "PAT";
  AuditLogResource["PROJECT"] = "PROJECT";
  AuditLogResource["ROLE"] = "ROLE";
  AuditLogResource["STAGE"] = "STAGE";
  AuditLogResource["VIEWGROUP"] = "VIEWGROUP";
  AuditLogResource["WEBHOOK"] = "WEBHOOK";
})(AuditLogResource || (AuditLogResource = {}));

var AuditLogTriggerType;

(function (AuditLogTriggerType) {
  AuditLogTriggerType["OPEN"] = "OPEN";
  AuditLogTriggerType["PAT"] = "PAT";
  AuditLogTriggerType["THIRD_PARTY"] = "THIRD_PARTY";
  AuditLogTriggerType["USER"] = "USER";
})(AuditLogTriggerType || (AuditLogTriggerType = {}));

var AvailableExtensionPermissionAction;

(function (AvailableExtensionPermissionAction) {
  AvailableExtensionPermissionAction["API"] = "API";
  AvailableExtensionPermissionAction["FORM"] = "FORM";
  AvailableExtensionPermissionAction["INPUT"] = "INPUT";
})(AvailableExtensionPermissionAction || (AvailableExtensionPermissionAction = {}));

var AvailableExtensionSrcType;

(function (AvailableExtensionSrcType) {
  AvailableExtensionSrcType["INLINE"] = "INLINE";
  AvailableExtensionSrcType["SDK"] = "SDK";
})(AvailableExtensionSrcType || (AvailableExtensionSrcType = {}));

var CacheControlScope;

(function (CacheControlScope) {
  CacheControlScope["PRIVATE"] = "PRIVATE";
  CacheControlScope["PUBLIC"] = "PUBLIC";
})(CacheControlScope || (CacheControlScope = {}));

var ColorPalette;

(function (ColorPalette) {
  ColorPalette["BROWN"] = "BROWN";
  ColorPalette["GREEN"] = "GREEN";
  ColorPalette["ORANGE"] = "ORANGE";
  ColorPalette["PINK"] = "PINK";
  ColorPalette["PURPLE"] = "PURPLE";
  ColorPalette["RED"] = "RED";
  ColorPalette["TEAL"] = "TEAL";
  ColorPalette["YELLOW"] = "YELLOW";
})(ColorPalette || (ColorPalette = {}));

var ColumnOrderByDir;

(function (ColumnOrderByDir) {
  ColumnOrderByDir["ASC"] = "ASC";
  ColumnOrderByDir["DESC"] = "DESC";
})(ColumnOrderByDir || (ColumnOrderByDir = {}));

var ComponentFieldType;

(function (ComponentFieldType) {
  ComponentFieldType["COMPONENT"] = "COMPONENT";
})(ComponentFieldType || (ComponentFieldType = {}));

var ComponentUnionFieldType;

(function (ComponentUnionFieldType) {
  ComponentUnionFieldType["COMPONENT_UNION"] = "COMPONENT_UNION";
})(ComponentUnionFieldType || (ComponentUnionFieldType = {}));

var ContentPermissionTargetKind;

(function (ContentPermissionTargetKind) {
  ContentPermissionTargetKind["PAT"] = "PAT";
  ContentPermissionTargetKind["PUBLIC"] = "PUBLIC";
  ContentPermissionTargetKind["ROLE"] = "ROLE";
})(ContentPermissionTargetKind || (ContentPermissionTargetKind = {}));

var ContentViewType;

(function (ContentViewType) {
  ContentViewType["BUILT_IN"] = "BUILT_IN";
  ContentViewType["PUBLIC"] = "PUBLIC";
})(ContentViewType || (ContentViewType = {}));

var EnumerableFieldType;

(function (EnumerableFieldType) {
  EnumerableFieldType["ENUMERATION"] = "ENUMERATION";
})(EnumerableFieldType || (EnumerableFieldType = {}));

var ExtensionFieldType;

(function (ExtensionFieldType) {
  ExtensionFieldType["ASSET"] = "ASSET";
  ExtensionFieldType["BOOLEAN"] = "BOOLEAN";
  ExtensionFieldType["COLOR"] = "COLOR";
  ExtensionFieldType["DATE"] = "DATE";
  ExtensionFieldType["DATETIME"] = "DATETIME";
  ExtensionFieldType["ENUMERATION"] = "ENUMERATION";
  ExtensionFieldType["FLOAT"] = "FLOAT";
  ExtensionFieldType["GRAPHQL"] = "GRAPHQL";
  ExtensionFieldType["ID"] = "ID";
  ExtensionFieldType["INT"] = "INT";
  ExtensionFieldType["JSON"] = "JSON";
  ExtensionFieldType["LOCATION"] = "LOCATION";
  ExtensionFieldType["RELATION"] = "RELATION";
  ExtensionFieldType["REST"] = "REST";
  ExtensionFieldType["RICHTEXT"] = "RICHTEXT";
  ExtensionFieldType["STRING"] = "STRING";
  ExtensionFieldType["UNION"] = "UNION";
})(ExtensionFieldType || (ExtensionFieldType = {}));
/** Type of feedback */


var FeedbackType;

(function (FeedbackType) {
  /** Used when deleting an account */
  FeedbackType["DELETE_ACCOUNT"] = "DELETE_ACCOUNT";
  /** Used when deleting a project */

  FeedbackType["DELETE_PROJECT"] = "DELETE_PROJECT";
  /** Used when downgrading a plan on a project */

  FeedbackType["DOWNGRADE_PLAN"] = "DOWNGRADE_PLAN";
  /** Used when sending a feedback from a new feature on the webapp */

  FeedbackType["FEATURE_FEEDBACK"] = "FEATURE_FEEDBACK";
  /** Used when sending a feedback from the feedback form on the webapp */

  FeedbackType["GENERAL_FEEDBACK"] = "GENERAL_FEEDBACK";
  /** Used when leaving a project */

  FeedbackType["LEAVE_PROJECT"] = "LEAVE_PROJECT";
})(FeedbackType || (FeedbackType = {}));

var FieldAppElementFeature;

(function (FieldAppElementFeature) {
  FieldAppElementFeature["FieldRenderer"] = "FieldRenderer";
  FieldAppElementFeature["ListRenderer"] = "ListRenderer";
  FieldAppElementFeature["TableRenderer"] = "TableRenderer";
})(FieldAppElementFeature || (FieldAppElementFeature = {}));

var GraphQlRemoteSourceIntrospectionMethod;

(function (GraphQlRemoteSourceIntrospectionMethod) {
  GraphQlRemoteSourceIntrospectionMethod["GET"] = "GET";
  GraphQlRemoteSourceIntrospectionMethod["POST"] = "POST";
})(GraphQlRemoteSourceIntrospectionMethod || (GraphQlRemoteSourceIntrospectionMethod = {}));

var Integration_Provider;

(function (Integration_Provider) {
  Integration_Provider["GATSBY_CLOUD"] = "GATSBY_CLOUD";
  Integration_Provider["NETLIFY"] = "NETLIFY";
})(Integration_Provider || (Integration_Provider = {}));

var LifecycleStepType;

(function (LifecycleStepType) {
  LifecycleStepType["API_PERMISSIONS_SET"] = "API_PERMISSIONS_SET";
  LifecycleStepType["CONTENT_ADDED"] = "CONTENT_ADDED";
  LifecycleStepType["EXPLORE_CONTENT_API"] = "EXPLORE_CONTENT_API";
  LifecycleStepType["EXTERNAL_TRAFFIC"] = "EXTERNAL_TRAFFIC";
  LifecycleStepType["SCHEMA_SETUP"] = "SCHEMA_SETUP";
})(LifecycleStepType || (LifecycleStepType = {}));

var LimitType;

(function (LimitType) {
  LimitType["API_OPERATIONS"] = "API_OPERATIONS";
  LimitType["ASSET_TRAFFIC"] = "ASSET_TRAFFIC";
  LimitType["AUDIT_LOGS_RETENTION_PERIOD"] = "AUDIT_LOGS_RETENTION_PERIOD";
  LimitType["CONTENT_MODELS"] = "CONTENT_MODELS";
  LimitType["CONTENT_PERMISSIONS"] = "CONTENT_PERMISSIONS";
  LimitType["CONTENT_STAGES"] = "CONTENT_STAGES";
  LimitType["ENVIRONMENTS"] = "ENVIRONMENTS";
  LimitType["INTEGRATIONS"] = "INTEGRATIONS";
  LimitType["LOCALES"] = "LOCALES";
  LimitType["MODELS"] = "MODELS";
  LimitType["PERMANENT_AUTH_TOKENS"] = "PERMANENT_AUTH_TOKENS";
  LimitType["RATE_LIMIT_PER_SECOND"] = "RATE_LIMIT_PER_SECOND";
  LimitType["RECORDS"] = "RECORDS";
  LimitType["REMOTE_FIELDS"] = "REMOTE_FIELDS";
  LimitType["REMOTE_FIELDS_HTTP_WORKERS"] = "REMOTE_FIELDS_HTTP_WORKERS";
  LimitType["REMOTE_FIELDS_MAX_EXECUTION_TIME"] = "REMOTE_FIELDS_MAX_EXECUTION_TIME";
  LimitType["REMOTE_FIELDS_MAX_RESPONSE_SIZE"] = "REMOTE_FIELDS_MAX_RESPONSE_SIZE";
  LimitType["REMOTE_SOURCES"] = "REMOTE_SOURCES";
  LimitType["ROLES"] = "ROLES";
  LimitType["SCHEDULING_OPERATIONS_IN_RELEASE"] = "SCHEDULING_OPERATIONS_IN_RELEASE";
  LimitType["SCHEDULING_PENDING_OPERATIONS"] = "SCHEDULING_PENDING_OPERATIONS";
  LimitType["SCHEDULING_PENDING_RELEASES"] = "SCHEDULING_PENDING_RELEASES";
  LimitType["SEATS"] = "SEATS";
  LimitType["VERSIONS"] = "VERSIONS";
  LimitType["VERSION_RETENTION_PERIOD"] = "VERSION_RETENTION_PERIOD";
  LimitType["WEBHOOKS"] = "WEBHOOKS";
  LimitType["WORKFLOW_STEPS"] = "WORKFLOW_STEPS";
})(LimitType || (LimitType = {}));

var MigrationOperationType;

(function (MigrationOperationType) {
  MigrationOperationType["BATCH"] = "BATCH";
  MigrationOperationType["CREATE_ENUMERABLE_FIELD"] = "CREATE_ENUMERABLE_FIELD";
  MigrationOperationType["CREATE_ENUMERATION"] = "CREATE_ENUMERATION";
  MigrationOperationType["CREATE_ENVIRONMENT"] = "CREATE_ENVIRONMENT";
  MigrationOperationType["CREATE_LOCALE"] = "CREATE_LOCALE";
  MigrationOperationType["CREATE_MODEL"] = "CREATE_MODEL";
  MigrationOperationType["CREATE_PROJECT_FROM_TEMPLATE"] = "CREATE_PROJECT_FROM_TEMPLATE";
  MigrationOperationType["CREATE_RELATIONAL_FIELD"] = "CREATE_RELATIONAL_FIELD";
  MigrationOperationType["CREATE_REMOTE_FIELD"] = "CREATE_REMOTE_FIELD";
  MigrationOperationType["CREATE_REMOTE_TYPE_DEFINITION"] = "CREATE_REMOTE_TYPE_DEFINITION";
  MigrationOperationType["CREATE_SIMPLE_FIELD"] = "CREATE_SIMPLE_FIELD";
  MigrationOperationType["CREATE_STAGE"] = "CREATE_STAGE";
  MigrationOperationType["CREATE_UNION_FIELD"] = "CREATE_UNION_FIELD";
  MigrationOperationType["DELETE_ENUMERATION"] = "DELETE_ENUMERATION";
  MigrationOperationType["DELETE_FIELD"] = "DELETE_FIELD";
  MigrationOperationType["DELETE_LOCALE"] = "DELETE_LOCALE";
  MigrationOperationType["DELETE_MODEL"] = "DELETE_MODEL";
  MigrationOperationType["DELETE_REMOTE_TYPE_DEFINITION"] = "DELETE_REMOTE_TYPE_DEFINITION";
  MigrationOperationType["DELETE_STAGE"] = "DELETE_STAGE";
  MigrationOperationType["UPDATE_ENUMERABLE_FIELD"] = "UPDATE_ENUMERABLE_FIELD";
  MigrationOperationType["UPDATE_ENUMERATION"] = "UPDATE_ENUMERATION";
  MigrationOperationType["UPDATE_LOCALE"] = "UPDATE_LOCALE";
  MigrationOperationType["UPDATE_MODEL"] = "UPDATE_MODEL";
  MigrationOperationType["UPDATE_RELATIONAL_FIELD"] = "UPDATE_RELATIONAL_FIELD";
  MigrationOperationType["UPDATE_REMOTE_TYPE_DEFINITION"] = "UPDATE_REMOTE_TYPE_DEFINITION";
  MigrationOperationType["UPDATE_SIMPLE_FIELD"] = "UPDATE_SIMPLE_FIELD";
  MigrationOperationType["UPDATE_STAGE"] = "UPDATE_STAGE";
  MigrationOperationType["UPDATE_UNION_FIELD"] = "UPDATE_UNION_FIELD";
})(MigrationOperationType || (MigrationOperationType = {}));

var MigrationStatus;

(function (MigrationStatus) {
  MigrationStatus["FAILED"] = "FAILED";
  MigrationStatus["QUEUED"] = "QUEUED";
  MigrationStatus["RUNNING"] = "RUNNING";
  MigrationStatus["SUCCESS"] = "SUCCESS";
  MigrationStatus["TIMEOUT"] = "TIMEOUT";
})(MigrationStatus || (MigrationStatus = {}));

var NetlifyBuildState;

(function (NetlifyBuildState) {
  NetlifyBuildState["BUILDING"] = "BUILDING";
  NetlifyBuildState["FAILED"] = "FAILED";
  NetlifyBuildState["PREPARING"] = "PREPARING";
  NetlifyBuildState["READY"] = "READY";
})(NetlifyBuildState || (NetlifyBuildState = {}));

var PermanentAuthTokenAudience;

(function (PermanentAuthTokenAudience) {
  PermanentAuthTokenAudience["CONTENT_API"] = "CONTENT_API";
  PermanentAuthTokenAudience["MANAGEMENT_API"] = "MANAGEMENT_API";
})(PermanentAuthTokenAudience || (PermanentAuthTokenAudience = {}));

var PermissionAction;

(function (PermissionAction) {
  PermissionAction["APP_CREATE"] = "APP_CREATE";
  PermissionAction["APP_DELETE"] = "APP_DELETE";
  PermissionAction["APP_INSTALLATION_CREATE"] = "APP_INSTALLATION_CREATE";
  PermissionAction["APP_INSTALLATION_DELETE"] = "APP_INSTALLATION_DELETE";
  PermissionAction["APP_INSTALLATION_UPDATE"] = "APP_INSTALLATION_UPDATE";
  PermissionAction["APP_UPDATE"] = "APP_UPDATE";
  PermissionAction["AUDIT_LOGS_READ"] = "AUDIT_LOGS_READ";
  PermissionAction["COMPONENT_CREATE"] = "COMPONENT_CREATE";
  PermissionAction["COMPONENT_DELETE"] = "COMPONENT_DELETE";
  PermissionAction["COMPONENT_READ"] = "COMPONENT_READ";
  PermissionAction["COMPONENT_UPDATE"] = "COMPONENT_UPDATE";
  PermissionAction["CONTENTVIEW_CREATE"] = "CONTENTVIEW_CREATE";
  PermissionAction["CONTENTVIEW_DELETE"] = "CONTENTVIEW_DELETE";
  PermissionAction["CONTENTVIEW_READ"] = "CONTENTVIEW_READ";
  PermissionAction["CONTENTVIEW_SYSTEM_UPDATE"] = "CONTENTVIEW_SYSTEM_UPDATE";
  PermissionAction["CONTENTVIEW_UPDATE"] = "CONTENTVIEW_UPDATE";
  PermissionAction["CONTENT_CREATE"] = "CONTENT_CREATE";
  PermissionAction["CONTENT_DELETE"] = "CONTENT_DELETE";
  PermissionAction["CONTENT_PERMISSION_CREATE"] = "CONTENT_PERMISSION_CREATE";
  PermissionAction["CONTENT_PERMISSION_DELETE"] = "CONTENT_PERMISSION_DELETE";
  PermissionAction["CONTENT_PERMISSION_READ"] = "CONTENT_PERMISSION_READ";
  PermissionAction["CONTENT_PERMISSION_UPDATE"] = "CONTENT_PERMISSION_UPDATE";
  PermissionAction["CONTENT_PUBLISH"] = "CONTENT_PUBLISH";
  PermissionAction["CONTENT_READ"] = "CONTENT_READ";
  PermissionAction["CONTENT_UPDATE"] = "CONTENT_UPDATE";
  PermissionAction["CONTENT_UPDATE_PUBLISHED"] = "CONTENT_UPDATE_PUBLISHED";
  PermissionAction["ENUMERATION_CREATE"] = "ENUMERATION_CREATE";
  PermissionAction["ENUMERATION_DELETE"] = "ENUMERATION_DELETE";
  PermissionAction["ENUMERATION_READ"] = "ENUMERATION_READ";
  PermissionAction["ENUMERATION_UPDATE"] = "ENUMERATION_UPDATE";
  PermissionAction["ENVIRONMENT_CREATE"] = "ENVIRONMENT_CREATE";
  PermissionAction["ENVIRONMENT_DELETE"] = "ENVIRONMENT_DELETE";
  PermissionAction["ENVIRONMENT_PROMOTE"] = "ENVIRONMENT_PROMOTE";
  PermissionAction["ENVIRONMENT_READ"] = "ENVIRONMENT_READ";
  PermissionAction["ENVIRONMENT_UPDATE"] = "ENVIRONMENT_UPDATE";
  PermissionAction["EXTENSION_CREATE"] = "EXTENSION_CREATE";
  PermissionAction["EXTENSION_DELETE"] = "EXTENSION_DELETE";
  PermissionAction["EXTENSION_READ"] = "EXTENSION_READ";
  PermissionAction["EXTENSION_UPDATE"] = "EXTENSION_UPDATE";
  PermissionAction["FIELD_CREATE"] = "FIELD_CREATE";
  PermissionAction["FIELD_DELETE"] = "FIELD_DELETE";
  PermissionAction["FIELD_READ"] = "FIELD_READ";
  PermissionAction["FIELD_UPDATE"] = "FIELD_UPDATE";
  PermissionAction["INTEGRATION_CREATE"] = "INTEGRATION_CREATE";
  PermissionAction["INTEGRATION_DELETE"] = "INTEGRATION_DELETE";
  PermissionAction["INTEGRATION_READ"] = "INTEGRATION_READ";
  PermissionAction["INTEGRATION_UPDATE"] = "INTEGRATION_UPDATE";
  PermissionAction["LOCALE_CREATE"] = "LOCALE_CREATE";
  PermissionAction["LOCALE_DELETE"] = "LOCALE_DELETE";
  PermissionAction["LOCALE_READ"] = "LOCALE_READ";
  PermissionAction["LOCALE_UPDATE"] = "LOCALE_UPDATE";
  PermissionAction["MANAGE_PAYMENT"] = "MANAGE_PAYMENT";
  PermissionAction["MODEL_CREATE"] = "MODEL_CREATE";
  PermissionAction["MODEL_DELETE"] = "MODEL_DELETE";
  PermissionAction["MODEL_READ"] = "MODEL_READ";
  PermissionAction["MODEL_UPDATE"] = "MODEL_UPDATE";
  PermissionAction["NETLIFY_TRIGGER_BUILD"] = "NETLIFY_TRIGGER_BUILD";
  PermissionAction["PAT_CREATE"] = "PAT_CREATE";
  PermissionAction["PAT_DELETE"] = "PAT_DELETE";
  PermissionAction["PAT_READ"] = "PAT_READ";
  PermissionAction["PAT_UPDATE"] = "PAT_UPDATE";
  PermissionAction["PLAYGROUND_USE"] = "PLAYGROUND_USE";
  PermissionAction["PROJECT_CLONE"] = "PROJECT_CLONE";
  PermissionAction["PROJECT_DELETE"] = "PROJECT_DELETE";
  PermissionAction["PROJECT_UPDATE"] = "PROJECT_UPDATE";
  PermissionAction["REMOTE_SOURCE_CREATE"] = "REMOTE_SOURCE_CREATE";
  PermissionAction["REMOTE_SOURCE_DELETE"] = "REMOTE_SOURCE_DELETE";
  PermissionAction["REMOTE_SOURCE_READ"] = "REMOTE_SOURCE_READ";
  PermissionAction["REMOTE_SOURCE_UPDATE"] = "REMOTE_SOURCE_UPDATE";
  PermissionAction["ROLE_CREATE"] = "ROLE_CREATE";
  PermissionAction["ROLE_DELETE"] = "ROLE_DELETE";
  PermissionAction["ROLE_UPDATE"] = "ROLE_UPDATE";
  PermissionAction["STAGE_CREATE"] = "STAGE_CREATE";
  PermissionAction["STAGE_DELETE"] = "STAGE_DELETE";
  PermissionAction["STAGE_READ"] = "STAGE_READ";
  PermissionAction["STAGE_UPDATE"] = "STAGE_UPDATE";
  PermissionAction["STORAGE_BUCKET_CREATE"] = "STORAGE_BUCKET_CREATE";
  PermissionAction["STORAGE_BUCKET_DELETE"] = "STORAGE_BUCKET_DELETE";
  PermissionAction["STORAGE_BUCKET_READ"] = "STORAGE_BUCKET_READ";
  PermissionAction["STORAGE_BUCKET_UPDATE"] = "STORAGE_BUCKET_UPDATE";
  PermissionAction["USER_ASSIGNROLE"] = "USER_ASSIGNROLE";
  PermissionAction["USER_INVITE"] = "USER_INVITE";
  PermissionAction["USER_REMOVE"] = "USER_REMOVE";
  PermissionAction["VIEW_GROUP_CREATE"] = "VIEW_GROUP_CREATE";
  PermissionAction["VIEW_GROUP_DELETE"] = "VIEW_GROUP_DELETE";
  PermissionAction["VIEW_GROUP_READ"] = "VIEW_GROUP_READ";
  PermissionAction["VIEW_GROUP_UPDATE"] = "VIEW_GROUP_UPDATE";
  PermissionAction["VIEW_ROLE_PERMISSION_SETTINGS"] = "VIEW_ROLE_PERMISSION_SETTINGS";
  PermissionAction["VIEW_SCHEMA"] = "VIEW_SCHEMA";
  PermissionAction["VIEW_TEAM_MEMBER_SETTINGS"] = "VIEW_TEAM_MEMBER_SETTINGS";
  PermissionAction["WEBHOOK_CREATE"] = "WEBHOOK_CREATE";
  PermissionAction["WEBHOOK_DELETE"] = "WEBHOOK_DELETE";
  PermissionAction["WEBHOOK_READ"] = "WEBHOOK_READ";
  PermissionAction["WEBHOOK_UPDATE"] = "WEBHOOK_UPDATE";
})(PermissionAction || (PermissionAction = {}));

var ProfileJobRole;

(function (ProfileJobRole) {
  ProfileJobRole["DEVELOPER_ENGINEERING"] = "DEVELOPER_ENGINEERING";
  ProfileJobRole["EDITORIAL_CONTENT"] = "EDITORIAL_CONTENT";
  ProfileJobRole["MANAGEMENT"] = "MANAGEMENT";
  ProfileJobRole["OTHER"] = "OTHER";
  ProfileJobRole["PROCUREMENT"] = "PROCUREMENT";
  ProfileJobRole["PRODUCT_MANAGEMENT"] = "PRODUCT_MANAGEMENT";
  ProfileJobRole["PROJECT_MANAGEMENT"] = "PROJECT_MANAGEMENT";
  ProfileJobRole["SALES"] = "SALES";
  ProfileJobRole["SECURITY_LEGAL"] = "SECURITY_LEGAL";
})(ProfileJobRole || (ProfileJobRole = {}));

var Remote_Graphql_Type;

(function (Remote_Graphql_Type) {
  Remote_Graphql_Type["ENUM"] = "ENUM";
  Remote_Graphql_Type["INPUT_OBJECT"] = "INPUT_OBJECT";
  Remote_Graphql_Type["INTERFACE"] = "INTERFACE";
  Remote_Graphql_Type["OBJECT"] = "OBJECT";
  Remote_Graphql_Type["SCALAR"] = "SCALAR";
  Remote_Graphql_Type["UNION"] = "UNION";
})(Remote_Graphql_Type || (Remote_Graphql_Type = {}));

var RelationalFieldType;

(function (RelationalFieldType) {
  RelationalFieldType["ASSET"] = "ASSET";
  RelationalFieldType["RELATION"] = "RELATION";
})(RelationalFieldType || (RelationalFieldType = {}));

var RemoteFieldApiMethod;

(function (RemoteFieldApiMethod) {
  RemoteFieldApiMethod["GET"] = "GET";
  RemoteFieldApiMethod["POST"] = "POST";
})(RemoteFieldApiMethod || (RemoteFieldApiMethod = {}));

var RemoteFieldType;

(function (RemoteFieldType) {
  RemoteFieldType["GRAPHQL"] = "GRAPHQL";
  RemoteFieldType["REST"] = "REST";
})(RemoteFieldType || (RemoteFieldType = {}));

var RemoteSourceType;

(function (RemoteSourceType) {
  RemoteSourceType["GRAPHQL"] = "GRAPHQL";
  RemoteSourceType["REST"] = "REST";
})(RemoteSourceType || (RemoteSourceType = {}));
/** Field types */


var SimpleFieldType;

(function (SimpleFieldType) {
  SimpleFieldType["BOOLEAN"] = "BOOLEAN";
  SimpleFieldType["COLOR"] = "COLOR";
  SimpleFieldType["DATE"] = "DATE";
  SimpleFieldType["DATETIME"] = "DATETIME";
  SimpleFieldType["FLOAT"] = "FLOAT";
  SimpleFieldType["ID"] = "ID";
  SimpleFieldType["INT"] = "INT";
  SimpleFieldType["JSON"] = "JSON";
  SimpleFieldType["LOCATION"] = "LOCATION";
  SimpleFieldType["RICHTEXT"] = "RICHTEXT";
  SimpleFieldType["STRING"] = "STRING";
})(SimpleFieldType || (SimpleFieldType = {}));

var SystemSidebarElementType;

(function (SystemSidebarElementType) {
  SystemSidebarElementType["INFORMATION"] = "INFORMATION";
  SystemSidebarElementType["LOCALIZATIONS"] = "LOCALIZATIONS";
  SystemSidebarElementType["PREVIEW_URLS"] = "PREVIEW_URLS";
  SystemSidebarElementType["RELEASES"] = "RELEASES";
  SystemSidebarElementType["STAGES"] = "STAGES";
  SystemSidebarElementType["VERSIONS"] = "VERSIONS";
})(SystemSidebarElementType || (SystemSidebarElementType = {}));

var TrackEvent;

(function (TrackEvent) {
  TrackEvent["CHECKED_QUICKSTART"] = "CHECKED_QUICKSTART";
  TrackEvent["CREATED_CONTENT"] = "CREATED_CONTENT";
  TrackEvent["USED_PLAYGROUND"] = "USED_PLAYGROUND";
})(TrackEvent || (TrackEvent = {}));

var UnionFieldType;

(function (UnionFieldType) {
  UnionFieldType["UNION"] = "UNION";
})(UnionFieldType || (UnionFieldType = {}));

var ViewGroupContentType;

(function (ViewGroupContentType) {
  ViewGroupContentType["ASSET"] = "ASSET";
  ViewGroupContentType["DEFAULT"] = "DEFAULT";
})(ViewGroupContentType || (ViewGroupContentType = {}));

var ViewGroupType;

(function (ViewGroupType) {
  ViewGroupType["CUSTOM"] = "CUSTOM";
  ViewGroupType["SYSTEM"] = "SYSTEM";
  ViewGroupType["USER_CREATED"] = "USER_CREATED";
})(ViewGroupType || (ViewGroupType = {}));

var VisibilityTypes;

(function (VisibilityTypes) {
  /** Field is not shown, and can only be read or edited through the API */
  VisibilityTypes["API_ONLY"] = "API_ONLY";
  /** Field is not shown, but can be used by other fields such as slugs or UI Extensions */

  VisibilityTypes["HIDDEN"] = "HIDDEN";
  /** Field is shown but can't be edited in the UI, only through the API */

  VisibilityTypes["READ_ONLY"] = "READ_ONLY";
  /** Field can be read and edited */

  VisibilityTypes["READ_WRITE"] = "READ_WRITE";
})(VisibilityTypes || (VisibilityTypes = {}));

var WebhookLogOrderByInput;

(function (WebhookLogOrderByInput) {
  WebhookLogOrderByInput["calledAt_ASC"] = "calledAt_ASC";
  WebhookLogOrderByInput["calledAt_DESC"] = "calledAt_DESC";
})(WebhookLogOrderByInput || (WebhookLogOrderByInput = {}));

var WebhookMethod;

(function (WebhookMethod) {
  WebhookMethod["DELETE"] = "DELETE";
  WebhookMethod["GET"] = "GET";
  WebhookMethod["POST"] = "POST";
  WebhookMethod["PUT"] = "PUT";
})(WebhookMethod || (WebhookMethod = {}));
/**
 * Defines which operation will trigger the webhook.
 * Some operations rely on the type of stage. E.g. on a
 * publishing stage, the webhook will only be triggered for
 * PUBLISH and UNPUBLISH events. On other stages, only
 * CREATE, UPDATE and DELETE are triggering the webhook.
 */


var WebhookTriggerAction;

(function (WebhookTriggerAction) {
  WebhookTriggerAction["CREATE"] = "CREATE";
  WebhookTriggerAction["DELETE"] = "DELETE";
  WebhookTriggerAction["PUBLISH"] = "PUBLISH";
  WebhookTriggerAction["UNPUBLISH"] = "UNPUBLISH";
  WebhookTriggerAction["UPDATE"] = "UPDATE";
})(WebhookTriggerAction || (WebhookTriggerAction = {}));

var WebhookTriggerSource;

(function (WebhookTriggerSource) {
  WebhookTriggerSource["MEMBER"] = "MEMBER";
  WebhookTriggerSource["PAT"] = "PAT";
  WebhookTriggerSource["PUBLIC"] = "PUBLIC";
})(WebhookTriggerSource || (WebhookTriggerSource = {}));
/** Defines the type of the trigger */


var WebhookTriggerType;

(function (WebhookTriggerType) {
  WebhookTriggerType["CONTENT_MODEL"] = "CONTENT_MODEL";
})(WebhookTriggerType || (WebhookTriggerType = {}));

var name$3 = yup__namespace.string().min(1).nullable(false);
var url = yup__namespace.string().nullable(false).url().httpsUrl().required();
var headerKey = yup__namespace.string().nullable(false).matches(/^[A-Z][A-Za-z0-9-]*$/, 'The key may only start with a capital letter and contain only alphanumeric characters.');
var headerValue = yup__namespace.string().nullable(false);
var secretKey = yup__namespace.string().nullable(true).min(32, 'Choose a secret key that is min. ${min} characters long.').max(64, 'The secret key may not exceed ${max} characters.').test({
  name: 'no-whitespace',
  test: function test(value) {
    return !/\s/g.test(value);
  },
  message: 'Whitespace is not allowed. Secret key could be alphanumeric with special characters',
  exclusive: false
});
var method = yup__namespace.string().oneOf(Object.keys(WebhookMethod));

var webhook = {
	__proto__: null,
	name: name$3,
	url: url,
	headerKey: headerKey,
	headerValue: headerValue,
	secretKey: secretKey,
	method: method
};

var apiId$2 = yup__namespace.string().min(1, 'Enter an Api Id.').max(64, 'Use an Api Id that is shorter than ${max} characters.').noGqlType().matches(/^[a-zA-Z][a-zA-Z0-9_]*$/, 'Start with a letter, and use only alphanumeric characters or underscores.');
var displayName$1 = yup__namespace.string().min(1, 'Enter a Display Name.').trim('The display name may not have leading or trailing whitespaces.');

var locale = {
	__proto__: null,
	apiId: apiId$2,
	displayName: displayName$1
};

var name$2 = yup__namespace.string().strict(true).trim('The view group name may not start or end with whitespace characters.').min(1, 'Choose a name for this view group.').max(32, 'Choose an name that is shorter than ${max} characters.');

var viewGroup = {
	__proto__: null,
	name: name$2
};

/**
 * Matcher for component api IDs:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .strict(:boolean)  -> Prevents manipulation of the string during validation
 * .min()             -> Sets minimum required length of string to 1 character
 * .max()             -> Sets maximum required length of string to 64 characters
 * .required()        -> Ensures that empty strings are treated as invalid value
 * .test()            -> Executes an arbitrary test on the input value
 * .matches(:RegExpr) -> Matches the input value against a regular expression
 */

var apiId$1 = yup__namespace.string().strict(true).min(1, 'Enter an Api ID.').max(64, 'Use an Api Id that is shorter than ${max} characters.').noGqlType().test({
  name: 'no-reserved-word',
  test: function test(value) {
    var options = this.options;

    if (options.context && options.context.isSystem) {
      return true;
    }

    return !reservedModelApiIds.some(function (reservedWord) {
      return value ? reservedWord.toLowerCase() === value.toLowerCase() : false;
    });
  },
  message: '"${value}" is a restricted word and cannot be used here.',
  exclusive: false
}).matches(/^[A-Z][a-zA-Z0-9_]*$/, 'Start with a capital letter and use only alphanumeric characters and underscores.'); // <-- Those are validations enforced by prisma: https://github.com/graphcool/prisma/blob/master/server/servers/deploy/src/main/scala/com/prisma/deploy/validation/NameConstraints.scala

/**
 * Matcher for component display names:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .strict(:boolean)  -> Prevents manipulation of the string during validation
 * .required()        -> Ensures that empty strings are treated as invalid value
 */

var displayName = yup__namespace.string().strict(true).min(1, 'Enter a Display Name').trim('Display names may not have leading or trailing whitespaces.');
/**
 * Matcher for component descriptions:
 *
 * .string()          -> Ensures that only strings can be validated with success
 * .ensure()          -> Transforms the values "undefined" and "null" into empty strings
 */

var description$1 = yup__namespace.string().ensure();
var componentId = yup__namespace.string().strict(true);

var component = {
	__proto__: null,
	apiId: apiId$1,
	displayName: displayName,
	description: description$1,
	componentId: componentId
};

var name$1 = yup__namespace.string().strict(true).min(1).ensure().trim('The name of an app may not start or end with white space characters.');
var apiId = yup__namespace.string().strict(true).min(1, 'Enter an Api Id.').max(64, 'Use an Api Id that is shorter than ${max} characters.').noGqlType().test({
  name: 'no-reserved-word',
  test: function test(value) {
    var options = this.options;

    if (options.context && options.context.isSystem) {
      return true;
    }

    return !reservedFieldApiIds.some(function (reservedWord) {
      return value ? reservedWord === value.toLowerCase() : false;
    });
  },
  message: '"${value}" is a restricted word and cannot be used here.',
  exclusive: false
}).matches(/^[a-z][a-zA-Z0-9_-]*$/, 'Start with a lowercase letter and use only alphanumeric characters, underscores and hyphens.');
var description = yup__namespace.string().nullable(true);
var urlSchema = yup__namespace.string().url().nullable(true);
var avatarUrl = urlSchema;
var setupUrl = urlSchema;
var webhookUrl = urlSchema;
var configurationUrl = urlSchema;
var CONFIG_TYPE = ['string', 'number', 'boolean'];

var configValueSchema = function configValueSchema() {
  return yup__namespace.object({
    type: yup__namespace.string().oneOf([].concat(CONFIG_TYPE)).required(),
    displayName: yup__namespace.string().nullable(true),
    description: yup__namespace.string().nullable(true),
    required: yup__namespace.bool().nullable(true),
    defaultValue: yup__namespace.mixed().nullable(true)
  });
};

var APP_ELEMENT_TYPES = ['field', 'formSidebar', 'page']; // TODO: import these from generated file once PR is merged

var FIELD_ELEMENT_TYPES = ['BOOLEAN', 'COLOR', 'DATE', 'DATETIME', 'FLOAT', 'ID', 'INT', 'JSON', 'LOCATION', 'RICHTEXT', 'STRING']; // and these too

var FIELD_ELEMENT_FEATURES = ['ListRenderer', 'TableRenderer', 'FieldRenderer'];
var element = {
  src: urlSchema,
  name: name$1,
  type: yup__namespace.string().oneOf([].concat(APP_ELEMENT_TYPES)),
  description: yup__namespace.string().nullable(true),
  config: yup__namespace.object().test('is-valid-config', 'invalid config', function (value) {
    var shape = {};
    Object.keys(value).forEach(function (key) {
      shape[key] = configValueSchema();
    });

    try {
      yup__namespace.object().shape(shape).validateSync(value);
    } catch (e) {
      if (e instanceof yup__namespace.ValidationError) return e;
    }

    return true;
  }),
  fieldType: yup__namespace.string().oneOf([].concat(FIELD_ELEMENT_TYPES)).nullable(true),
  features: yup__namespace.array().of(yup__namespace.string().oneOf([].concat(FIELD_ELEMENT_FEATURES))).nullable(true)
};

var app = {
	__proto__: null,
	name: name$1,
	apiId: apiId,
	description: description,
	avatarUrl: avatarUrl,
	setupUrl: setupUrl,
	webhookUrl: webhookUrl,
	configurationUrl: configurationUrl,
	CONFIG_TYPE: CONFIG_TYPE,
	APP_ELEMENT_TYPES: APP_ELEMENT_TYPES,
	FIELD_ELEMENT_TYPES: FIELD_ELEMENT_TYPES,
	FIELD_ELEMENT_FEATURES: FIELD_ELEMENT_FEATURES,
	element: element
};

var name = yup__namespace.string().nullable(false).strict(true).min(1).test('no-html-tags', 'HTML tags are not allowed', function (value) {
  var hasHtmlTags = /<[^>]*>/g;
  return !hasHtmlTags.test(value);
});

var user = {
	__proto__: null,
	name: name
};

exports["default"] = yup__namespace;
exports.appValidation = app;
exports.authtoken = authtoken;
exports.component = component;
exports.enumeration = enumeration;
exports.field = field;
exports.invite = invite;
exports.locale = locale;
exports.model = model;
exports.project = project;
exports.role = role;
exports.stage = stage;
exports.user = user;
exports.viewGroup = viewGroup;
exports.webhook = webhook;
Object.keys(yup).forEach(function (k) {
	if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () { return yup[k]; }
	});
});
//# sourceMappingURL=validation.js.map
